import { render, staticRenderFns } from "./ConfirmationCustomer.vue?vue&type=template&id=b65768ba"
import script from "./ConfirmationCustomer.vue?vue&type=script&lang=js"
export * from "./ConfirmationCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports